// Import site url's
import Index from "@/views/site/index";
import Micro from "@/views/site/micro";
import Business from "@/views/site/buisiness";
import HowToGet from "@/views/site/how-to-get";
import HowToPayOff from "@/views/site/how-to-pay-off";
import Contacts from "@/views/site/contacts";
import QuestionsAnswers from "@/views/site/questions-answers";
import Question from "@/views/site/question";
import GeneralConditions from "@/views/site/GeneralConditions";
import Answer from "@/views/site/answer";

import RepayBankCard from "@/views/site/repay/bankCard";
import RepayCashTerminals from "@/views/site/repay/cashTerminals";
import RepayElectronicWallets from "@/views/site/repay/electronicWallets";
import RepayBankTransaction from "@/views/site/repay/bankTransaction";

import Error from "@/views/404";

export const site = [
    {
        path: "micro",
        name: "Micro",
        component: Micro,
    },
    {
        path: "business",
        name: "Business",
        component: Business,
    },
    {
        path: "how-to-get",
        name: "How_to_get",
        component: HowToGet
    },
    {
        path: "how-to-pay-off",
        name: "How_to_pay_off",
        component: HowToPayOff,
        redirect: RepayBankCard,
        children: [
            {
                path: "bank-card",
                name: "RepayBankCard",
                component: RepayBankCard
            },
            {
                path: "cash-terminals",
                name: "RepayCashTerminals",
                component: RepayCashTerminals,
            },
            {
                path: "bank-transaction",
                name: "RepayBankTransaction",
                component: RepayBankTransaction,
            },
            {
                path: "electronic-wallets",
                name: "RepayElectronicWallets",
                component: RepayElectronicWallets,
            },
        ]
    },
    {
        path: "contacts",
        name: "Contacts",
        component: Error
    },
    {
        path: "faq",
        name: "FAQ",
        component: QuestionsAnswers,
        redirect: {
            path: "faq/often-asked",
        },
        children: [
            {
                path: ":questionName",
                name: "QuestionType",
                component: Question,
                children: [
                    {
                        path: ":answerName",
                        name: "AnswerType",
                        component: Question
                    }
                ]
            }
        ]
    },
    {
        path: "general-conditions",
        name: "GeneralConditions",
        component: GeneralConditions
    },
    {
        path: "cabinet",
        name: "Cabinet",
        component: Error
    },
    {
        path: "",
        name: "Index",
        component: Index
    }
];